import React from 'react'
import { OrderSide } from './'
import { Icon } from 'loyal-react'
import OrderProductItem from './OrderProductItem'
import TrackingItem from './TrackingItem'
import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'

const tracking = true

const mockTracking = {
  items: [
    {
      updatedAt: '2019-02-16T16:20:17.058Z',
      createdAt: '2019-02-16T16:20:17.058Z',
      sku: '2213156',
      trackingUrl:
        'https://status.ondeestameupedido.com/tracking/e43e06fc16ff1f21f6245f595b48aaf42e36ef3a',
      deliveryForecasts: [
        {
          additionalDays: 15,
          deliveryForecast: '2018-11-19T00:00:00.000Z',
          createdAt: '2019-02-16T16:20:16.588Z'
        }
      ],
      statuses: [
        {
          vendorStatus: '1',
          description: 'Pedido Realizado - SUCESSO',
          when: '2018-11-14T04:45:00.000Z',
          createdAt: '2019-02-16T16:20:16.588Z',
          origin: 'VENDOR'
        },
        {
          vendorStatus: '2',
          description:
            'Pagamento - Recebemos a confirmação do pagamento de seu pedido e vamos dar continuidade ao processo de envio.',
          when: '2018-11-14T04:47:00.000Z',
          createdAt: '2019-02-16T16:20:16.588Z',
          origin: 'VENDOR'
        },
        {
          vendorStatus: '3',
          description: 'Separação em Estoque - Sucesso',
          when: '2018-11-14T05:17:00.000Z',
          createdAt: '2019-02-16T16:20:16.588Z',
          origin: 'VENDOR'
        },
        {
          vendorStatus: '4',
          description: 'Produto em Transporte - Produto em transporte',
          when: '2018-11-14T10:59:00.000Z',
          createdAt: '2019-02-16T16:20:16.588Z',
          origin: 'VENDOR'
        },
        {
          vendorStatus: '6',
          description: 'Entrega - Devolução',
          when: '2018-12-13T17:54:00.000Z',
          createdAt: '2019-02-16T16:20:16.588Z',
          origin: 'VENDOR'
        }
      ]
    }
  ]
}

const Order = props => (
  <div className='container-fluid px-0 px-md-1 bg-ui-4'>
    <div className='container pt-5 pb-2 py-md-4'>
      <div className='row pt-5 pt-md-0 mt-5 mt-md-0'>
        <div className='cart-side col-12 col-md-8 px-0 pl-md-1 pr-md-2'>
          <div className='border-ui-3 radius bg-white'>
            <div className='col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'>
              <h3 className='color-brand-1 txt-uppercase txt-circular-black'>
                PEDIDO: #00000001
              </h3>
            </div>
            <OrderProductItem />

            <div
              className={`row mx-0 px-3 bg-ui-5  border-color-ui-3 border-bottom py-2 ${
                tracking ? 'd-none' : ''
              }`}
            >
              <div className='cart-shipping col-12 px-0'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-auto'>
                    <Icon
                      iconName='icon_truck'
                      className='color-brand-1 icon'
                    />
                  </div>
                  <div className='col'>
                    <div className='col py-half px-0 txt-body-sm'>
                      <p className='txt-body-sm'>
                        Transportadora: <strong>Correios</strong>
                      </p>
                      <p className='txt-body-sm'>
                        Código de rastreamento: <strong>OF992903803BR</strong>
                      </p>
                      <p className='txt-body-sm'>
                        Pedido realizado: <strong>06/11/2018</strong>
                      </p>
                    </div>
                  </div>
                  <div className='col-12 col-md-4 pl-half'>
                    <button className='btn-sm'>Rastrear Pedido</button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`row mx-0 px-3 border-color-ui-3 border-bottom py-2 ${
                !tracking ? 'd-none' : ''
              }`}
            >
              <div className='order-tracking col-12 px-0 pb-1'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-12 pb-3'>
                    <h3 className='color-ui-2 txt-uppercase txt-body txt-circular-black'>
                      DETALHE DO RASTREAMENTO
                    </h3>
                  </div>
                  <TrackingItem tracking={mockTracking} />
                </div>
              </div>
            </div>
            <div className='row py-1 px-0 d-none d-md-block'>
              <div className='cart-back col-12 col-md-5 px-0 txt-left'>
                <button className='btn btn-sm btn-flat btn-icon'>
                  <Icon className='icon icon-sm icon_left' />
                  Ver todos os pedidos
                </button>
              </div>
            </div>
          </div>
        </div>
        <OrderSide />
      </div>
    </div>
  </div>
)

export default Order



// WEBPACK FOOTER //
// ./src/features/User/Orders/Order.js